import React, { ReactNode } from 'react';

import { Route } from 'react-router-dom';
import { CloseButtonTypes, FullPageModal } from 'src/presentation/components/agent_desktop_components';
import useRouter from 'src/presentation/hooks/useRouter';

type FullPageModalRouteProps = {
  componentRenderer: ({ id, root }: { id: string; root: string }) => ReactNode;
  root: string;
  path: string;
};

const FullPageModalRoute = ({ path, root, componentRenderer }: FullPageModalRouteProps) => {
  const { match } = useRouter();

  return (
    <Route
      exact
      path={`${match.path}${path}`}
      render={({ match }) => (
        <FullPageModal
          closeButtonType={CloseButtonTypes.NONE}
          content={componentRenderer({ id: match.params.id!, root })}
          preventCloseOnEscape={true}
          topPadding={0}
          visible={true}
        />
      )}
    ></Route>
  );
};

export default FullPageModalRoute;
